export const ASYNC_STATUS = {
    awaiting: 1,
    running: 2,
    finished: 3,
    error: 4,
};

export const CODE_RESPONSE = Object.freeze({
    success: 200,
    error: 400
});